import { useBilingual } from "@/lib/bilingual";

const ProcessOverview = () => {
  const b = useBilingual();

  const steps = [
    {
      step: "01",
      label: b("Sourcing", "原料採購"),
      icon: "ri-leaf-line",
      description: b(
        "Kiln-dried hardwoods, engineered panels, upholstery foams and finishing materials are selected against Forwaro's approved-supplier list, with traceability kept for every inbound batch.",
        "實木經窯乾處理、工程板、泡棉與表面處理材料皆來自 Forwaro 核可供應商名單，每批進料皆保有可追溯紀錄。",
      ),
    },
    {
      step: "02",
      label: b("Joinery", "木作組立"),
      icon: "ri-tools-line",
      description: b(
        "CNC cutting, dowel and mortise-and-tenon joinery, plus reinforced corner blocks ensure every frame ships with export-grade structural integrity.",
        "CNC 切割、榫接與企口接合，加上加固角料，確保每件框架皆達到外銷等級的結構強度。",
      ),
    },
    {
      step: "03",
      label: b("Upholstery", "軟包縫製"),
      icon: "ri-scissors-cut-line",
      description: b(
        "Fabrics and leathers are hand-cut to pattern, layered with high-density foam, and hand-finished by experienced upholsterers for consistent seam work.",
        "布料與皮料依紙型手工裁剪，搭配高密度泡棉分層，由資深軟包師傅手工收尾，確保縫線一致。",
      ),
    },
    {
      step: "04",
      label: b("Finishing", "表面處理"),
      icon: "ri-paint-brush-line",
      description: b(
        "Multi-stage lacquer, stain and top-coat applications are baked and polished between passes to deliver Forwaro's signature depth and evenness.",
        "多道塗裝、染色與面漆處理，每道之間皆烘烤與拋光，呈現 Forwaro 一貫的深度與均勻度。",
      ),
    },
    {
      step: "05",
      label: b("Quality Control", "品質控管"),
      icon: "ri-shield-check-line",
      description: b(
        "Pre-shipment inspection covers dimensions, hardware function, finish consistency, and packing integrity before any container is sealed.",
        "出貨前檢查尺寸、五金功能、表面處理一致性與包裝完整性，確認後才會封櫃出運。",
      ),
    },
  ];

  return (
    <section className="py-14 md:py-24 bg-stone-50">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="mb-14">
          <p className="text-amber-700 text-xs font-semibold tracking-widest uppercase mb-3">
            {b("How We Make It", "製造流程")}
          </p>
          <h2
            className="text-3xl md:text-5xl font-bold text-stone-900"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {b("Our Production Process", "Forwaro 五階段生產流程")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, idx) => (
            <div key={step.label} className="relative flex flex-col">
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(50%+28px)] right-0 h-px bg-amber-700/20 z-0" />
              )}

              <div className="relative z-10 flex flex-col gap-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-amber-700/10 border border-amber-700/25 text-amber-700 self-start">
                  <i className={`${step.icon} text-2xl`} />
                </div>
                <p className="text-amber-600/50 text-xs font-bold tracking-widest">{step.step}</p>
                <p
                  className="text-stone-900 text-xl font-bold"
                  style={{ fontFamily: "var(--font-display)" }}
                >
                  {step.label}
                </p>
                <p className="text-stone-500 text-xs leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessOverview;
